<template>
    <div v-for="group in data" :key="group.id" class="side-group">
        <template v-for="item in group.items" :key="item.id" >
            <v-badge v-if="item.badge && item.badge.content > 0" dot :content="item.badge.content" :color="item.badge.color">
                <div v-ripple class="component" :class="{ active : active(item) }" v-if="item.component"
                    @click="navigate(item)" :title="item.title">
                    <component  v-if="item.component" :is="item.component" v-bind="item.payload" />
                </div>
                <tool-button v-else :icon="item.icon" :image="item.image" class="side-group-item"
                    :class="{ active : active(item) }" @click="navigate(item)" :title="group.title + ': ' + item.title">
                </tool-button>
            </v-badge>
            <div v-ripple class="component" :class="{ active : active(item) }" v-else-if="item.component"
                @click="navigate(item)" :title="item.title">
                <component  v-if="item.component" :is="item.component" v-bind="item.payload" />
            </div>
            <tool-button v-else :icon="item.icon" :image="item.image" class="side-group-item"
                :class="{ active : active(item) }" @click="navigate(item)" :title="group.title + ': ' + item.title">
            </tool-button>
        </template>
        <v-divider></v-divider>
    </div>
</template>

<script>
import ToolButton from './ToolButton.vue';
import ToolIcon from './ToolIcon.vue';

export default {
    components: {
        ToolIcon,
        ToolButton,
    },
    name: 'SideBar',
    props: {
        data: Array,
    },
    methods: {
        navigate(item) {
            this.$emit('navigate', item.route);
        },
        active(item) {
            const active = item.active;
            if (active == null) {
                return this.$router.match(item.route);
            }
            return active;
        },
    },
};
</script>

<style scoped>
.side-group {
    display: table;
    margin: 0 auto;
    text-align: center;
}

.side-group-item {
    opacity: var(--v-medium-emphasis-opacity);
    display: flex;
}

.side-group-item.active {
    color: rgb(var(--v-theme-primary)) !important;
}

.component {
    display: flex;
    width: 48px;
    height: 48px;
    margin: 0px;
    padding: 0px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

.component.active {
    background: rgb(var(--v-theme-on-surface-variant)) !important;
}

.component:hover {
    background: rgb(var(--v-theme-on-surface-variant)) !important;
}
</style>
